import { render, staticRenderFns } from "./ManageAcademy.vue?vue&type=template&id=8d75f536&scoped=true"
import script from "./ManageAcademy.vue?vue&type=script&lang=js"
export * from "./ManageAcademy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d75f536",
  null
  
)

export default component.exports